export const FEATURE_LIST_LOCAL_STORAGE = "featureList";
export const FEATURE_LIST_HEADER = "x-feature-list";
export const CSRF = "csrf"
